import React from 'react'
import TitleBar from '../../components/navbar/TitleBar'
import NavMenu from '../../components/navbar/NavMenu'
import DashboardDatas from '../../components/dashboard/DashboardDatas'
import DashboardMapFilter from '../../components/dashboard/DashboardMapFilter'
import Footer from '../../components/common/Footer'

export default function DashboardNew() {
  return (
    <>
      <TitleBar />
      <NavMenu/>
      <DashboardDatas/>
      <DashboardMapFilter dashboard />
      <Footer/>
    </>
  )
}
